import React, { useContext, useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { ConfigContext } from "../context/GlobalContext";
import ExpenseListLayer from "../components/ExpenseListLayer";
import { Languages } from "../Utils/Languages";

const ExpenseListPage = () => {

  const { state } = useContext(ConfigContext);


  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title={Languages[state?.LANGUAGE]?.expense_list} />

        {/* InvoiceListLayer */}
        <ExpenseListLayer businessData={state?.BUSINESSES} expenseData={state?.EXPENSE} />

      </MasterLayout>


    </>
  );
};

export default ExpenseListPage;
